module.exports = __webpack_public_path__ + "static/media/Scroll_to_top.ca69f725.svg";